import { ApiResult, request, safeRequest } from '@synergy/api';
import { SponsorBanner } from '@synergy/models';

import { SponsorBannerDetailRequest } from '../models/sponsor-banner-detail-request';

export class SponsorBannerDetailApi {
    constructor(protected baseUrl: string) {}

    public getSponsorBannerDetail(id: number): Promise<ApiResult<SponsorBanner>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/sponsor-banners/${id}`),
            response => response.data
        );
    }

    public updateSponsorBannerDetail = (
        sponsorBanner: SponsorBannerDetailRequest
    ): Promise<ApiResult<SponsorBanner>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/sponsor-banners/${sponsorBanner.id}`, sponsorBanner),
            response => response.data
        );
    };

    public createSponsorBannerDetail = (
        sponsorBanner: SponsorBannerDetailRequest
    ): Promise<ApiResult<SponsorBanner>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/sponsor-banners`, sponsorBanner),
            response => response.data
        );
    };
}
